import React from 'react'
import {notification, Progress} from 'antd'
import styles from './UploadControl.module.scss'
import {BgColorsOutlined} from "@ant-design/icons";

function UploadProgressBar({uploadRequest, uploadedFilesList, uploadFileRequestState, uploadProgress}) {

    return (
        <>
            {(!!uploadRequest || uploadedFilesList.length) && !uploadProgress? (
                <Progress
                    percent={!uploadRequest && uploadedFilesList.length ? 100 : uploadFileRequestState?.progressOverall?.progress}
                    size='small'
                    status='normal'
                    className={styles.progress}
                    strokeColor={uploadFileRequestState?.progressOverall?.progress ? '#43E090' : '#80AAFF'}
                />
            ) : null}
        </>
    )
}

export default UploadProgressBar
